import { createSlice } from "@reduxjs/toolkit";
// eslint-disable-next-line no-duplicate-imports
import type { PayloadAction } from "@reduxjs/toolkit";

import type { SignupFormSubmitRequestPayloadType } from "./Register.types";


interface RegisterState {
  recaptchaV2SiteKey?: string;
}

const initialState: RegisterState = {
};

const registerSlice = createSlice({
  name: "register",
  initialState,
  reducers: {
    openAcceptEmcModal(state) {
      return {
        ...state
      };
    },
    signupFormSubmitRequest(state, action: PayloadAction<SignupFormSubmitRequestPayloadType>) {
      return state;
    },
    setRecaptchaV2SiteKey(state, action: PayloadAction<string>) {
      state.recaptchaV2SiteKey = action.payload;
    },
    destroy() {
      return initialState;
    }
  }
});


export default registerSlice.reducer;
export const { signupFormSubmitRequest, setRecaptchaV2SiteKey, destroy } = registerSlice.actions;
export const registerActions = registerSlice.actions;
